module.exports = __webpack_public_path__ + "static/media/Unique-Host-Reseller.1f27d7fd.png";